export const DATA = {
  "Skill level": "Beginner",
  "Time to complete": "Approx. 60 hours",
  Certificate: "Included",
  Prerequesties: "None",
  description:
    "Master Digital Creativity for Social Media, Branding & Print Design",
  about:
    "Learn complete guide to graphic designers: From beginners to professionals using Photoshop, Illustrator, InDesign, and CorelDraw. Creating logos, social media content, brochures, and motion graphics.",
  skills: ["Visual Communication", "Brand Identity", "Designing Softwares"],
  reviews: {
    1: {
      name: "Sienna Park",
      review:
        "This Graphic Designing course was an amazing experience! I learned the fundamentals of visual composition, color harmony, and typography in a very clear way.",
    },
    2: {
      name: "Hugo Almeida",
      review:
        "The instructor broke down design principles so well. I especially enjoyed the logo creation and branding modules. Very beginner-friendly.",
    },
    3: {
      name: "Marina Kovac",
      review:
        "I absolutely loved the hands-on exercises. The course helped me understand layout design and gave me the confidence to create my own posters.",
    },
    4: {
      name: "Declan Marsh",
      review:
        "Such a well-taught program! The lessons on color psychology, hierarchy, and digital illustration were incredibly insightful.",
    },
    5: {
      name: "Isadora Menezes",
      review:
        "Great course for anyone wanting to start designing. The assignments were fun and helped me improve quickly.",
    },
    6: {
      name: "Alec Romano",
      review:
        "The course had the perfect balance of theory and practical work. I now understand how to create clean, professional-looking designs.",
    },
    7: {
      name: "Priya Narang",
      review:
        "I loved learning about brand identity, layouts, and design software. Everything was explained in a very simple, motivating way.",
    },
    8: {
      name: "Grant Holloway",
      review:
        "Amazing lessons! The typography module alone was worth it. I’ve already applied what I learned to real freelance projects.",
    },
    9: {
      name: "Zoe Blackwell",
      review:
        "Very clear, well-paced, and practical. The instructor taught design principles in a way that even beginners can understand easily.",
    },
    10: {
      name: "Alberto Vargas",
      review:
        "I appreciated how carefully everything was explained—from choosing fonts to building a complete brand theme. Excellent course!",
    },
    11: {
      name: "Juna Andersson",
      review:
        "This course really boosted my creativity. I enjoyed every activity, especially the poster and social media design challenges.",
    },
    12: {
      name: "Meline Sarkis",
      review:
        "The demonstrations were super helpful. Seeing the design process step-by-step made it easier to apply the techniques myself.",
    },
    13: {
      name: "Oscar Dahl",
      review:
        "A fantastic introduction to the world of design. I learned so much about layout balance and visual storytelling.",
    },
    14: {
      name: "Ananya Mitra",
      review:
        "I really enjoyed experimenting with shapes, icons, and color schemes. The instructor’s feedback was always encouraging and helpful.",
    },
    15: {
      name: "Jayden Rivers",
      review:
        "This course helped me understand how professional designs are created. The lessons on contrast, spacing, and alignment were extremely useful.",
    },
    16: {
      name: "Emilia Toscano",
      review:
        "Everything was explained in simple terms. I feel much more confident working with design tools and creating appealing layouts.",
    },
    17: {
      name: "Tobias Jenson",
      review:
        "The best part is the practical approach. Each lesson includes activities that test your creativity and design thinking.",
    },
    18: {
      name: "Kayla Fincher",
      review:
        "I learned how to use colors and typography effectively. This course made me understand the finer details of graphic design.",
    },
    19: {
      name: "Leonardo Battista",
      review:
        "A well-designed course about designing! The examples, case studies, and assignments were excellent.",
    },
    20: {
      name: "Fatima Al-Bader",
      review:
        "This course opened my eyes to the world of creative design. The branding module helped me create my first complete visual identity.",
    },
    21: {
      name: "Cedric Wallace",
      review:
        "The software tutorials were very easy to follow. I’ve already made several designs for my portfolio thanks to this course.",
    },
    22: {
      name: "Nailah Cooper",
      review:
        "A fun and engaging learning experience. I learned how to design attractive posts, posters, and banners.",
    },
    23: {
      name: "Mikhail Sokolov",
      review:
        "Great course! The instructor explained design principles clearly and showed how to apply them in real projects.",
    },
    24: {
      name: "Lorelai Greene",
      review:
        "The course enhanced my creativity and helped me develop a strong understanding of clean, effective design.",
    },
    25: {
      name: "Aarav Menon",
      review:
        "Very inspiring! The lessons encouraged me to explore different design styles and tools confidently.",
    },
  },
  modules: {
    "Fundamentals of Design & Visual Aesthetics": [],
    "Typography Principles & Text Design": [],
    "Color Theory": [],
    "Image Editing & Retouching (Photoshop)": [],
    "Vector Design & Logo Creation (Illustrator/CorelDraw)": [],
    "Poster, Flyer, & Banner Design": [],
    "Business Card & Brochure Design": [],
    "Layout & Publishing (InDesign)": [],
    "Motion Graphics and Animation": [],
    "Animated Text & Logo Intros": [],
    "Working with Layers, Masks & Filters": [],
    "Pen Tool Mastery for Custom Vector Graphics": [],
    "Print vs Digital Design Guidelines": [],
    "Creating GIFs & Simple Animations": [],
  },
};
